import { render, staticRenderFns } from "./Good.vue?vue&type=template&id=2f240cc8&scoped=true&"
import script from "./Good.vue?vue&type=script&lang=js&"
export * from "./Good.vue?vue&type=script&lang=js&"
import style0 from "./Good.vue?vue&type=style&index=0&id=2f240cc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f240cc8",
  null
  
)

export default component.exports